export const AUTH = {
    //设置加载状态
    SET_LOADING: 'setLoading',
    //设置请求状态
    SET_IS_REQUEST:'setIsRequest',
    //设置有权限的菜单列表
    SET_MENUS: 'setMenus',
    //设置有权限的路由列表
    SET_ROUTES: 'setRoutes',
    //设置有权限的按钮列表
    SET_BTNS: 'setBtns'
}

export const LIST = {
    //设置加载状态
    SET_LOADING: 'setLoading',
    //设置请求状态
    SET_IS_REQUEST:'setIsRequest',
    //街道
    SET_STREET_LIST: 'setstreet_list',
    //社区
    SET_COMMUNITY_LIST:'setcommunity_list',
    //场所类型
    SET_PLACE_TYPE_LIST: 'setplace_type_list',
	//综合编码类别
	SET_MISC_TYPE_LIST: 'setmisc_type_list',
}